import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    background: theme.colors.cloud,
    borderRadius: '12px',
    display: 'flex',
    justifyContent: 'center',
    maxHeight: '500px',
    overflow: 'hidden',
  },
  header: {
    marginTop: '-20px',
  },
  title: {
    justifyContent: 'space-between',
    fontSize: '32px',
  },
  headerContent: {
    fontSize: '24px',
    lineHeight: 1.4,
    color: theme.colors.charcoal, // TODO use branding
  },
  description: {
    // fontSize: '24px',
    // lineHeight: 1.4,
    // color: theme.colors.charcoal, // TODO use branding
  },
  subHeading: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: theme.colors.charcoal,
  },
  fullDescription: {
    fontSize: '18px',
    lineHeight: 1.5,
    color: theme.colors.smoke,
  },
}));

export default useStyles;
